import { HStack, Pressable, Text, VStack } from '@rbilabs/universal-components';

import { ITopServiceModeWithFutureOrderingViewProps } from './types';

/**
 * Top Service Mode view for Future Ordering.
 */
export const TopServiceModeFutureOrderingView: React.FC<React.PropsWithChildren<
  ITopServiceModeWithFutureOrderingViewProps
>> = ({ heading, details, icon, button, futureOrderDate, onTopServiceClick }) => {
  return (
    <Pressable
      testID="top-service-mode"
      onPress={onTopServiceClick}
      _web={{ cursor: 'pointer' }}
      backgroundColor={Styles.color.background}
    >
      <HStack
        testID="top-service-mode-wrapper"
        borderRadius="lg"
        space="$2"
        justifyContent="space-between"
        alignItems="center"
        margin="$4"
        background="white"
        padding="$3"
        paddingLeft="$4"
        paddingRight="$4"
        shadow="2"
      >
        <HStack space="$3" alignItems="center">
          <Text marginY="$1">{icon}</Text>
          <VStack>
            <Text
              variant="copyOne"
              fontWeight="bold"
              fontSize={{
                base: 'lg',
                md: 'lg',
              }}
            >
              {heading}
            </Text>
            {futureOrderDate && (
              <Text
                variant="copyOne"
                fontWeight="bold"
                fontSize="sm"
                ellipsizeMode="tail"
                numberOfLines={1}
              >
                {futureOrderDate}
              </Text>
            )}
            {details && <Text fontSize="xs">{details}</Text>}
          </VStack>
        </HStack>
        <Text>{button}</Text>
      </HStack>
    </Pressable>
  );
};
